/**
 * 通过自动发现钱包，但是又需要单独构造 wallet hub 对象的场景，主要是针对 多链钱包，例如okex、phantom等
 */

import { BtcConnector } from '../connectors/btc/BtcConnector';
import { Web3ProviderConnector } from '../connectors/evm/Web3ProviderConnector';
import { SolanaConnector } from '../connectors/solana/SolanaConnector';
import { StacksConnector } from '../connectors/stx/StacksConnector';
import { TonConnector } from '../connectors/ton/TonConnector';
import { WalletHub } from '../core/WalletHub';
import { WalletTag } from '../Web3WalletHubCenter';

const constructPhantom = (detail: any) => {
  return new WalletHub({
    name: detail.info.name,
    id: detail.info.rdns,
    icon: detail.info.icon,
    tags: [WalletTag.scan],
    connectors: [
      new Web3ProviderConnector('phantom-evm', detail.provider),
      // 暂时不去加sol的btc，以后btc 有需求统一再加，避免增加代码的复杂度
      // new BtcConnector('phantom-btc', () => window['phantom']?.bitcoin),
      new SolanaConnector('phantom-solana', () => window['phantom']?.solana),
    ],
  });
};

const constructOkex = (detail: any) => {
  return new WalletHub({
    name: detail.info.name,
    id: detail.info.rdns,
    icon: detail.info.icon,
    tags: [WalletTag.scan],
    connectors: [
      new Web3ProviderConnector('okex-evm', detail.provider),
      new BtcConnector('okex-btc', () => window['okxwallet']?.bitcoin),
      new SolanaConnector('okex-solana', () => window['okxwallet']?.solana),
      // ton 连接比较特殊，不会自动授权，所以先不加这里
      // new TonConnector('okex-ton', () => window['okxwallet']?.ton),
      new StacksConnector('okex-stx', () => window['okxwallet']?.stacks),
    ],
  });
};

export const autoFindConstructors: Record<string, (detail: any) => WalletHub> = {
  'app.phantom': constructPhantom,
  'com.okex.wallet': constructOkex,
};
